var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSShapeLogo = function SvgSShapeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 30,
    fill: "none",
    viewBox: "0 0 90 30"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#412592",
    d: "M0-10.976 21.197-36.15l4.474 2.998q-6.662 15.105-4.38 27.258 2.28 12.156 13.036 19.361 5.763 3.863 10.95 3.617t8.806-4.544q7.109-8.442-5.786-27.65l-.797-1.133Q36.13-33.107 35.223-41.939q-.909-8.832 6.072-17.121 10.404-12.356 26.987-12.71 16.58-.355 34.391 11.58 6.71 4.496 12.893 10.26 6.18 5.763 11.901 12.717l-17.643 20.954-4.302-2.883q3.067-14.512.967-22.884-2.105-8.373-9.674-13.445-5.68-3.806-11.306-3.675-5.63.131-8.924 4.045-5.495 6.525 7.77 26.096a65 65 0 0 1 1.611 2.401Q97.958-8.721 98.706-.179q.746 8.545-6.427 17.063-10.535 12.51-27.923 13.105-17.39.593-34.682-10.995-8.432-5.651-15.85-13.143T0-10.976"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0-11h99v41H0z"
  })))));
};
export default SvgSShapeLogo;